<template>
	<div class="system-wrapper" :class="En ? 'system-wrapper-en' : ''">
		<div class="pub-inner-head"></div>
		<innerTop :text="En ? 'Exhibitor Service System' : '展商服务系统'"></innerTop>
		<div class="system" :class="En ? 'system-en' : 'system-cn'">
			<div class="item" @click="fn1">
				<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/system-icon1.png" alt="">
				<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/system-icon1-active.png" alt="">
				<div class="big">{{ En ? 'Exhibitor Service System' : '展商服务系统' }}</div>
				<div class="small">{{ En ? 'If you are the exhibitor, please log in to the Exhibitor Service System.' : '如果您是展商，请登录展商服务系统。' }}</div>
				<a href="https://www.ciif-expo.cn/ciifExhibitor" target="_blank" class="btn">{{ En ? 'LOGIN' : '登录' }}</a>
			</div>
			<div class="item" @click="fn2">
				<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/system-icon2.png" alt="">
				<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/system-icon2-active.png" alt="">
				<div class="big">{{ En ? 'Intelligent Exhibition Service System' : '智能化主场系统' }}</div>
				<div class="small">{{ En ? 'If you are the booth contractor, please log in to the Intelligent Exhibition Service System.' : '如您是搭建商，请登录智能化主场系统。' }}</div>
				<a href="https://www.hdcrm.cn" target="_blank" class="btn">{{ En ? 'LOGIN' : '登录' }}</a>
			</div>
		</div>
		<!-- <div class="wap-system" v-else @click="$store.commit('setShowSystem', false)">
			<div class="wap-system-content">
				<img src="@/assets/images/system-icon3.png" alt="">
				<div class="big">{{ En ? 'Login Prompt' : '登录提示' }}</div>
				<div class="small">{{ En ? 'If you are an exhibitor, please log in from the official website on the PC side.' : '展商请前往PC端官网进行登录' }}</div>
			</div>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'system',
	data() {
		return {

		}
	},
	created() {
		this.pageView('ciif_exServices_exLoginDetails')
	},
	methods: {
		fn1() {
			this.$jsAPI('track', 'ciif_exServices_exLogin')
		},
		fn2() {
			this.$jsAPI('track', 'ciif_exServices_znhzcLogin')
		},
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {

	.system {
		width: 100%;
		height: 982px;
		padding-top: 274px;
		display: flex;
		justify-content: center;
		background-color: #F7F8F9;

		.item {
			width: 800px;
			height: 540px;
			background: #fff;
			border-radius: 24px;
			margin: 0 20px;
			padding: 60px 60px 0;
			position: relative;
			z-index: 1;

			img {
				width: 120px;
				height: 120px;

				&.img1 {
					display: block;
				}

				&.img2 {
					display: none;
				}
			}

			.big {
				font-family: syb;
				font-weight: 600;
				font-size: 40px;
				color: #0B243F;
				line-height: 48px;
				text-align: left;
				font-style: normal;
				margin: 40px 0 16px;
			}

			.small {
				height: 160px;
				font-family: MiSans Normal;
				font-weight: 400;
				font-size: 22px;
				color: #000000;
				line-height: 36px;
				text-align: left;
				font-style: normal;
			}

			.btn {
				position: absolute;
				left: 60px;
				bottom: 40px;
				height: 56px;
				padding: 0 20px;
				background: #fff;
				border: 1px solid rgba(11, 36, 63, 0.6);
				border-radius: 12px;
				font-size: 16px;
				font-family: syb;
				font-weight: 500;
				color: #0B243F;
				line-height: 1;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				&::after {
					content: "";
					display: block;
					width: 24px;
					height: 16px;
					background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png);
					background-size: cover;
					margin-left: 16px;
				}
			}

			&:hover {
				background: #F4501C;
				box-shadow: 0px 10px 40px 0px rgba(244, 80, 28, 0.3);

				.big {
					color: #fff;
				}

				.small {
					color: #fff;
				}

				.btn {
					border-color: #fff;
				}

				img {

					&.img1 {
						display: none;
					}

					&.img2 {
						display: block;
					}
				}
			}
		}

		&.system-cn {

			.item:hover {
				background: #F4501C;
				box-shadow: 0px 10px 40px 0px rgba(244, 80, 28, 0.3);

				.big {
					color: #fff;
				}

				.small {
					color: #fff;
				}

				.btn {
					border-color: #fff;
				}

				img {

					&.img1 {
						display: none;
					}

					&.img2 {
						display: block;
					}
				}
			}
		}

		&.system-en {
			padding-bottom: 82px;
			height: auto;

			.item {

				.small {
					margin-bottom: 10px;
					height: auto;
					font-family: MiSans, MiSans;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {

	.system-wrapper {
		background-color: #F7F8F9;
		padding-bottom: .8rem;
	}

	.system {
		width: 100%;

		.item {
			width: 7.02rem;
			height: 6rem;
			background: #fff;
			border-radius: .24rem;
			margin: 0 auto .4rem;
			padding: .6rem .4rem .4rem;
			position: relative;

			img {
				width: 1.2rem;
				height: 1.2rem;

				&.img1 {
					display: block;
				}

				&.img2 {
					display: none;
				}
			}

			.big {
				font-family: syb;
				font-size: .4rem;
				color: #0B243F;
				line-height: .48rem;
				text-align: left;
				font-style: normal;
				margin: .4rem 0 .16rem;
			}

			.small {
				font-family: MiSans Normal;
				font-weight: 400;
				font-size: .26rem;
				color: #000000;
				line-height: .4rem;
				text-align: left;
				font-style: normal;
			}

			.btn {
				position: absolute;
				left: .4rem;
				bottom: .4rem;
				height: .88rem;
				padding: 0 .28rem;
				background: #fff;
				border: 1px solid rgba(11, 36, 63, 0.6);
				border-radius: .2rem;
				font-size: .24rem;
				font-family: syb;
				font-weight: 500;
				color: #0B243F;
				line-height: 1;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				&::after {
					content: "";
					display: block;
					width: .36rem;
					height: .24rem;
					background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png);
					background-size: cover;
					margin-left: .12rem;
				}
			}

			&:nth-child(1) {
				background: #F4501C;
				box-shadow: 0px 10px 40px 0px rgba(244, 80, 28, 0.3);

				.big {
					color: #fff;
				}

				.small {
					color: #fff;
				}

				.btn {
					border-color: #fff;
				}

				img {

					&.img1 {
						display: none;
					}

					&.img2 {
						display: block;
					}
				}
			}
		}

		&.system-cn {

			.item:hover {
				background: #F4501C;
				box-shadow: 0px 10px 40px 0px rgba(244, 80, 28, 0.3);

				.big {
					color: #fff;
				}

				.small {
					color: #fff;
				}

				.btn {
					border-color: #fff;
				}

				img {

					&.img1 {
						display: none;
					}

					&.img2 {
						display: block;
					}
				}
			}
		}

		&.system-en {
			padding-bottom: 82px;
			height: auto;

			.item {

				.big {
					font-size: 22px;
					line-height: 48px;
					font-family: MiSans, MiSans;
					font-weight: normal;
					margin: 40px 0 10px;
				}

				.small {
					margin-bottom: 10px;
					height: auto;
					font-family: MiSans, MiSans;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/system/index.vue